import React from "react"
import { useLocation } from "react-router-dom"
import { Typography } from "antd"
import AiLogo from "../../assets/images/ai_sparkle_filled.svg"

import "./ChatbotEmptyDrawer.scss"

const { Title, Text } = Typography

export default function ChatbotEmptyDrawer() {
  const { pathname } = useLocation()

  const info = React.useMemo(() => {
    if (pathname.includes("study") && pathname.includes("study-data")) {
      return {
        title: "On this study page, I can help you QC your study. You can ask me questions like:",
        items: [
          "Does my Official Title look okay?",
          "Are my study's Outcome Measures aligned with my company's pre-approved measures?",
          "Can you perform a QC check for all my study data?",
        ],
      }
    } else {
      return {
        title:
          "On this page, I can access Xogene's Prime HelpDesk articles, including Best Practices, Tips & Tricks, FAQs, and User Guides. For detailed information, inquiries, or to report bugs or enhancement requests, please contact Xogene Support. However, feel free to ask me questions like:",
        items: [
          "How can I dismiss an alert for a study?",
          "How do I subscribe to receive email notifications for action items assigned to me?",
          "How do I submit site updates to PRS?",
        ],
      }
    }
  }, [pathname])

  return (
    <div className="chatbot-empty-drawer">
      <img
        className="ai-logo-container"
        src={AiLogo}
        alt="ai-empty-chatbot-drawer"
      />
      <Title
        className="ai-empty-title"
        level={4}
      >
        {info.title}
      </Title>
      <ul>
        {info.items.map((item, index) => (
          <li key={index}>
            <Text>{item}</Text>
          </li>
        ))}
      </ul>
    </div>
  )
}
